import React from 'react';

export const checkLanguage = () => {
  if (window.Localize) return window.Localize.getLanguage();
  if (navigator.language) return navigator.language.replace(/-.+/, '');
  return 'en';
};

export const useLocale = () => {
  const [locale, setLocale] = React.useState(checkLanguage);

  React.useEffect(() => {
    const updateLanguage = () => {
      setLocale(checkLanguage);
    };

    window.Localize?.on('setLanguage', updateLanguage);

    return () => {
      window.Localize?.off('setLanguage', updateLanguage);
    };
  }, []);

  return locale;
};
